import { Helmet } from 'react-helmet';

export default function Community() {
  return (
    <>
      <Helmet>
        <title>Community - Join the RailTech Community</title>
        <meta name="description" content="Join the RailTech community to connect with other AI enthusiasts and professionals." />
      </Helmet>

      <div className="bg-white">
        {/* Hero Section */}
        <div className="relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20">
          <div className="mx-auto max-w-7xl px-6 pb-24 pt-10 sm:pb-32 lg:flex lg:px-8 lg:py-40">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:flex-shrink-0 lg:pt-8">
              <h1 className="mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                Join Our Community
              </h1>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                Join our active Discord community where we talk about AI agents, platform updates, security, and the future of trusted AI. 
                Early product discussions and real feedback happen here.
              </p>
              <div className="mt-10 flex items-center gap-x-6">
                <a
                  href="https://discord.gg/6EVTKz9YgE"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Join Discord
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Community Features */}
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-24 sm:py-32">
          <div className="mx-auto max-w-2xl lg:text-center">
            <h2 className="text-base font-semibold leading-7 text-indigo-600">Community Features</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Connect and Collaborate
            </p>
          </div>
          <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
              <div className="flex flex-col">
                <dt className="text-base font-semibold leading-7 text-gray-900">Product Discussions</dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">Engage in meaningful discussions about AI infrastructure and security.</p>
                </dd>
              </div>
              <div className="flex flex-col">
                <dt className="text-base font-semibold leading-7 text-gray-900">Technical Support</dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">Get help from our team and community members.</p>
                </dd>
              </div>
              <div className="flex flex-col">
                <dt className="text-base font-semibold leading-7 text-gray-900">Updates & News</dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">Stay informed about platform updates and new features.</p>
                </dd>
              </div>
            </dl>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="bg-gray-50 py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Stay Updated
              </h2>
              <p className="mx-auto mt-2 max-w-xl text-lg leading-8 text-gray-600">
                Follow us on social media to stay updated about the latest news and updates.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 